import { render, staticRenderFns } from "./form_order_tapes.vue?vue&type=template&id=178aceca&scoped=true&"
import script from "./form_order_tapes.vue?vue&type=script&lang=js&"
export * from "./form_order_tapes.vue?vue&type=script&lang=js&"
import style0 from "./form_order_tapes.vue?vue&type=style&index=0&id=178aceca&lang=scss&scoped=true&"
import style1 from "./form_order_tapes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178aceca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178aceca')) {
      api.createRecord('178aceca', component.options)
    } else {
      api.reload('178aceca', component.options)
    }
    module.hot.accept("./form_order_tapes.vue?vue&type=template&id=178aceca&scoped=true&", function () {
      api.rerender('178aceca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_order_tapes.vue"
export default component.exports